import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, cloneElement } from 'react';
import { cn } from '../utils/cn.js';
/**
 * Labelled form-field wrapper. Wires up:
 *   - label[for] ↔ input[id]
 *   - hint / error rendered below the input
 *   - aria-describedby points the input at the hint/error
 *   - aria-invalid set when error is present
 *
 * Use case:
 *   <Field label="Email" hint="We'll send your sign-in link here.">
 *     <Input type="email" placeholder="you@example.com" />
 *   </Field>
 */
export function Field({ label, hint, error, optional, id: idProp, className, children, }) {
    const autoId = useId();
    const id = idProp ?? autoId;
    const hintId = hint ? `${id}-hint` : undefined;
    const errorId = error ? `${id}-error` : undefined;
    const describedBy = error ? errorId : hintId;
    return (_jsxs("div", { className: cn('flex flex-col gap-1.5', className), children: [_jsxs("label", { htmlFor: id, className: "font-body text-sm font-medium text-ink", children: [label, optional && _jsx("span", { className: "ml-1 text-ink-muted", children: "(optional)" })] }), cloneElement(children, {
                id,
                'aria-describedby': describedBy,
                'aria-invalid': error ? true : undefined,
            }), error ? (_jsx("p", { id: errorId, className: "font-body text-sm text-danger", children: error })) : hint ? (_jsx("p", { id: hintId, className: "font-body text-sm text-ink-muted", children: hint })) : null] }));
}
//# sourceMappingURL=Field.js.map